module.exports = __webpack_public_path__ + "e0244b60ea93aafb7c28e793c34d61d5.svg";